module.exports = "<p>带间距</p>\n";